export default __webpack_public_path__ + "static/media/17.1978b779.webp";